function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { useEffect, useCallback, useMemo } from 'react';
// Because events are handled at the document level, we provide a mechanism for early return.
var stopPropagation = true;
/**
 * Calls all handlers in reverse order
 * @param event The MouseEvent generated by the click event.
 */

function handleClick(event) {
  if (!event.defaultPrevented) {
    var _iterator = _createForOfIteratorHelper(Object.values(registry).reverse()),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var handler = _step.value;
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (handler(event) === stopPropagation || event.defaultPrevented) {
          break;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
}
var registry = {};
function register(id, handler) {
  registry[id] = handler;
}
function deregister(id) {
  delete registry[id];
} // For auto-incrementing unique identifiers for registered handlers.

var handlerId = 0;
export var useOnOutsideClick = function useOnOutsideClick(_ref) {
  var containerRef = _ref.containerRef,
    ignoreClickRefs = _ref.ignoreClickRefs,
    onClickOutside = _ref.onClickOutside;
  var id = useMemo(function () {
    return handlerId++;
  }, []);
  var handler = useCallback(function (event) {
    var _containerRef$current;

    // don't call click handler if the mouse event was triggered by an auxiliary button (right click/wheel button/etc)
    if (event instanceof MouseEvent && event.button > 0) {
      return stopPropagation;
    } // don't call handler if the click happened inside of the container

    if ((_containerRef$current = containerRef.current) !== null && _containerRef$current !== void 0 && _containerRef$current.contains(event.target)) {
      return stopPropagation;
    } // don't call handler if click happened on an ignored ref

    if (ignoreClickRefs && ignoreClickRefs.some(function (_ref2) {
      var current = _ref2.current;
      return current === null || current === void 0 ? void 0 : current.contains(event.target);
    })) {
      return stopPropagation;
    }
    onClickOutside(event);
  }, [containerRef, ignoreClickRefs, onClickOutside]);
  useEffect(function () {
    if (Object.keys(registry).length === 0) {
      // use capture to ensure we get all events
      document.addEventListener('mousedown', handleClick, {
        capture: true
      });
    }
    register(id, handler);
    return function () {
      deregister(id);
      if (Object.keys(registry).length === 0) {
        document.removeEventListener('mousedown', handleClick, {
          capture: true
        });
      }
    };
  }, [id, handler]);
};